<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 25 25"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-miterlimit="10"
    stroke-width="1.5"
  >
    <path
      d="M5.856 8.805a2.162 2.162 0 1 0 0-4.325 2.162 2.162 0 0 0 0 4.325ZM8.953 4.972a2.162 2.162 0 1 0 0-4.325 2.162 2.162 0 0 0 0 4.325ZM15.046 4.972a2.162 2.162 0 1 0 0-4.325 2.162 2.162 0 0 0 0 4.325ZM5.856 17.898v4.472a.933.933 0 1 1-1.868 0v-4.914M7.772 17.505v4.914a.933.933 0 1 1-1.867 0v-4.521M3.989 17.259c-.688-.54-1.18-1.376-1.18-2.31v-3.735a2.412 2.412 0 0 1 2.408-2.408h1.327a2.412 2.412 0 0 1 2.408 2.408v3.735c0 .934-.442 1.818-1.18 2.31M12 8.805a2.162 2.162 0 1 0 0-4.324 2.162 2.162 0 0 0 0 4.324ZM12 17.898v4.472a.933.933 0 1 1-1.868 0v-4.914M13.916 17.505v4.914a.933.933 0 1 1-1.867 0v-4.521"
    />
    <path
      d="M10.083 17.259c-.688-.54-1.18-1.376-1.18-2.31v-3.735a2.412 2.412 0 0 1 2.409-2.408h1.327a2.412 2.412 0 0 1 2.408 2.408v3.735c0 .934-.443 1.818-1.18 2.31M18.142 8.805a2.162 2.162 0 1 0 0-4.325 2.162 2.162 0 0 0 0 4.325ZM18.143 17.898v4.472a.933.933 0 1 1-1.868 0v-4.914"
    />
    <path
      d="M20.01 17.505v4.914a.933.933 0 1 1-1.868 0v-4.521M16.226 17.259c-.688-.54-1.18-1.376-1.18-2.31v-3.735a2.412 2.412 0 0 1 2.409-2.408h1.327a2.412 2.412 0 0 1 2.408 2.408v3.735c0 .934-.443 1.818-1.18 2.31"
    />
  </svg>
</template>
